import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../assets/imgs/logo.svg'
import _imports_1 from '../assets/imgs/close.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header_menu" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "hamburger hide-mobile" }
const _hoisted_5 = {
  key: 0,
  class: "hamburger",
  id: "hamburger"
}
const _hoisted_6 = { class: "hamburger__header" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "hamburger__address" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", {
    id: "header",
    class: 
      `${
        _ctx.currentRouteName === 'Request Demo' ||
        (_ctx.currentRouteName === 'Sign Up' && _ctx.currentRouteSignup == 'developer') ||
        _ctx.currentRouteName === 'Select For Signup' ||
        _ctx.currentRouteName === 'Sign Up Success'
          ? 'theme-dark'
          : ''
      }`
    
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "hamburger-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hamburger = !_ctx.hamburger))
        }),
        _createVNode("div", {
          class: "logo",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linktohome()))
        }, [
          _hoisted_3
        ]),
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
            return (_openBlock(), _createBlock("a", {
              class: "menu",
              key: menu.id,
              href: 
              _ctx.isExternal(menu.to) || menu.to == '/login' || menu.to == '/agent'
                ? menu.to
                : `#${menu.to}`
            ,
              innerHTML: menu.title
            }, null, 8, ["href", "innerHTML"]))
          }), 128))
        ]),
        (_ctx.hamburger)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("img", {
                    src: _imports_1,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hamburger = !_ctx.hamburger))
                  })
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
                  return (_openBlock(), _createBlock("a", {
                    class: "menu",
                    key: menu.id,
                    href: 
                _ctx.isExternal(menu.to) ||
                menu.to == '/login' ||
                menu.to == '/agent'
                  ? menu.to
                  : `#${menu.to}`
              ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hamburger = !_ctx.hamburger)),
                    innerHTML: menu.title
                  }, null, 8, ["href", "innerHTML"]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("a", {
                  href: 'tel:' + _ctx.tel,
                  innerHTML: _ctx.tel
                }, null, 8, ["href", "innerHTML"]),
                _createVNode("div", { innerHTML: _ctx.address }, null, 8, ["innerHTML"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", null, [
        _createVNode(_component_Button, {
          text: _ctx.agentLogin,
          btnType: "secondary",
          class: "btn-login hide-mobile",
          to: "/login"
        }, null, 8, ["text"]),
        _createVNode(_component_Button, {
          text: _ctx.signup,
          class: "btn-signup",
          to: "/select-for-signup"
        }, null, 8, ["text"])
      ])
    ])
  ], 2))
}